import { Component, OnInit } from '@angular/core';
import { CiacService } from 'src/app/services/http/ciac.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lista-consultas-ciac',
  templateUrl: './lista-consultas-ciac.component.html',
  styleUrls: ['./lista-consultas-ciac.component.scss']
})
export class ListaConsultasCiacComponent implements OnInit {
  
  sorting: { 
    id: "asc",
    nome: ""
  }

  filter = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };
  
  total:number = 0;
  tableLoading = true;
  listaConsultas = [];

  constructor(private ciacService: CiacService, private modalMsgService: ModalMsgService, private modalService: NgbModal, private router: Router) { }

  ngOnInit() {
    this.getListaConsultas();
  }

  removeEmpty(obj) {
    this.listaConsultas = [];
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  getListaConsultas() {
    this.filter.sorting = this.removeEmpty({ ...this.sorting });
    let dataUpdate = this.filter.data;
    this.ciacService.getListaConsultasCredito(this.filter).then(c => {
      if(dataUpdate == this.filter.data) {
        this.tableLoading = false;
        this.total = c.total || 0;
        this.listaConsultas = this.listaConsultas.concat(c.lista) || [];
      }
    });
    if(this.listaConsultas.length == 0) {
      this.tableLoading = false;
    }
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.getListaConsultas();
  }

  nextPage() {
    this.getListaConsultas();
  }

  editConsulta(id) {
    this.router.navigate(['ciac', 'consultas', 'editar', id ]);
  }

  delConsulta(id) {
    let params = {
      id: parseInt(id)
    }
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover consulta CIAC';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.ciacService.delConsultaCiac(justificativa, params)
          .then(r => this.getListaConsultas())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover consulta', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover consulta',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover consulta',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

  redirectDCS(id) {
    this.router.navigate(['ciac', 'consultas', 'dados-consulta-saida', id]);
  }

}
